import React from 'react';
import { Row } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import Checkbox from 'components/partials/Fields/FormikCheckbox';
import { AUCTION_BUYER, FACILITY_MANAGER, PRIVATE_SELLER} from 'helpers/users';
import { FormValues } from '../types';
import Link from 'components/Link';

const marketingMessageMap: { [key: number]: string } = {
    [FACILITY_MANAGER.id]: 'I understand that by checking the box above, I am providing explicit consent to receive marketing communications from StorageTreasures. I acknowledge that I can unsubscribe from these communications at any time by following the instructions provided in the messages.',
    [PRIVATE_SELLER.id]: 'I understand that by checking the box above, I am providing explicit consent to receive marketing communications from StorageTreasures. I acknowledge that I can unsubscribe from these communications at any time by following the instructions provided in the messages.',
    [AUCTION_BUYER.id]: 'I understand that by checking the box above, I am providing explicit consent to receive marketing communications from StorageTreasures. I acknowledge that I can unsubscribe from these communications at any time by following the instructions provided in the messages. My consent is voluntary, and I can update my communication settings at any time through my Notification Settings.',
};

interface AgreementSectionProps {
    regTypeId: number
}

const AgreementSection: React.FC<AgreementSectionProps> = ({ regTypeId }) => {
    const { errors, touched, dirty } = useFormikContext<FormValues>();
    
    return (
        <>
            <Row>
                <h2 className="section-title">User Agreement & Privacy Policy</h2>
            </Row>
            <div className="field-container agreementArea" id="agreementArea">
                <div id="agreement-error-message" />
                {(errors.terms || errors.privacy || errors.agree) &&
                (touched.terms && touched.privacy && touched.agree) &&
                dirty ?
                    <p className="parsley-errors-list filled">
                        These items are required to complete your registration. Please select all 3 boxes below.
                    </p> : null}
                <Checkbox
                    name="terms"
                    label={<>
                            I have read and agree to the {' '}
                        <a href="/terms" target="_blank" rel="nofollow noopener">
                            Terms of Use
                        </a>.
                    </>}
                />
                <Checkbox
                    name="privacy"
                    label={<>
                            I have read and agree to the {' '}
                        <a href="/privacy" target="_blank" rel="nofollow noopener">
                            Privacy Policy
                        </a>.
                    </>
                    }
                />
                <Checkbox
                    name="agree"
                    label='I consent to receiving communications related to my account from StorageTreasures via email.'
                />
                {regTypeId === AUCTION_BUYER.id && (
                    <>
                        <p className="marginT30"><strong>SMS/Text Consent</strong></p>
                        <Checkbox
                            name="opt_in_text"
                            label="I would like to opt in to receiving account-related updates via SMS/Text message from StorageTreasures.com."
                        />
                        <p className="marginT10">
                            I understand that by checking the box above, I am providing explicit consent to receive transactional SMS/Text messages, related to my account from StorageTreasures. 
                            Message and data rates may apply. Reply STOP to opt out. Consent is not required to use StorageTreasures services. For more details, please review our <Link to="/terms" target="_blank">Terms of Use</Link> and <Link to="/privacy" target="_blank">Privacy Policy</Link>.
                        </p>
                        <p className="marginB0">Regarding communication through text messages:</p>
                        <ul>
                            <li>Message and data rates may apply.</li>
                            <li>Reply STOP to opt out at any time.</li>
                            <li>Consent is not required to use StorageTreasures services.</li>
                            <li>For more details, please review our Terms of Use and Privacy Policy.</li>
                        </ul>
                    </>
                )}

                <p className="marginT30"><strong>Marketing and Promotional Communications</strong></p>
                <Checkbox
                    name="opt_in_email"
                    label="I would like to receive communications via email, including information related to online auctions in my area, offers, product updates, and others promotional communications."
                />
                <p className="marginT10">
                    {marketingMessageMap[regTypeId]}
                </p>
            </div>
        </>
    );
};

export default AgreementSection;